import { Link } from 'react-router-dom';
import { comments, articles } from '@/mocks/articles';

interface ArticleCommentsProps {
  articleSlug: string;
}

export default function ArticleComments({ articleSlug }: ArticleCommentsProps) {
  const articleComments = comments.filter((c) => c.articleSlug === articleSlug);
  const relatedArticles = articles.filter((a) => a.slug !== articleSlug).slice(0, 6);

  return (
    <>
      <section className="w-full bg-background-50 py-16 md:py-24">
        <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-col items-center text-center mb-14">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 rounded-full bg-accent-500" />
              <span className="text-xs text-foreground-500 font-medium tracking-wide uppercase">
                网友评论
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              吃瓜群众的<br />真实声音
            </h2>
            <p className="mt-3 text-foreground-500 text-sm">
              来自全网各平台网友的评论与反馈
            </p>
          </div>

          {articleComments.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articleComments.map((comment, index) => (
                <div
                  key={comment.id}
                  className={`bg-background-100 rounded-xl p-6 flex flex-col gap-4 transition-all duration-300 hover:-translate-y-1 ${
                    index === articleComments.length - 1 ? 'opacity-60' : ''
                  }`}
                >
                  <div className="flex items-center gap-1">
                    {Array.from({ length: comment.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm w-4 h-4 flex items-center justify-center" />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-3 pt-2 border-t border-background-200/70">
                    <img
                      src={comment.userAvatar}
                      alt={comment.userName}
                      className="w-9 h-9 rounded-full object-cover"
                    />
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-foreground-900">{comment.userName}</span>
                      <span className="text-xs text-foreground-400">{comment.platform} · {comment.date}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-foreground-400 text-sm py-8">
              暂无评论，来做第一个吃瓜群众吧
            </div>
          )}
        </div>
      </section>

      <section className="relative w-full min-h-[450px] md:min-h-[550px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20atmospheric%20abstract%20background%20with%20soft%20coral%20and%20cream%20gradients%2C%20dreamy%20editorial%20style%2C%20gentle%20texture%2C%20inviting%20warm%20tone&width=1800&height=900&seq=cta-article&orientation=landscape')`,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45" />

        <div className="relative z-10 w-full max-w-3xl mx-auto px-6 flex flex-col items-center text-center py-20">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            更多精彩爆料
          </h2>
          <p className="mt-4 text-background-50/80 text-sm max-w-md">
            查看更多吃瓜网黑料国产精品内容，不错过任何一个瓜
          </p>
          <Link
            to="/category/heiliao-heji"
            className="group mt-8 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-accent-500">
              <i className="ri-fire-line text-background-50 text-xs w-4 h-4 flex items-center justify-center" />
            </span>
            进入黑料合集
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>
      </section>
    </>
  );
}